;(function($) {

  'use strict';

  var pluginName = 'dropdown',
  namespace = 'plugin_' + pluginName;

  /*-------------------------------------------- */
  /** Plugin Defaults */
  /*-------------------------------------------- */

  var defaults = {
    trigger: null,
    displayEvent: 'click',
    hideDelay: 3000,
    mouseLeaveDelay: 500,
    toggledClass: 'active',
    showCallback: $.noop,
    hideCallback: $.noop,
    dismissOnDocumentClick: true
  };

  /*-------------------------------------------- */
  /** Helpers */
  /*-------------------------------------------- */

  function callMethod(instance, method, args) {
    if ( $.isFunction(instance[method]) ) {
      instance[method].apply(instance, args);
    }
  }

  /*-------------------------------------------- */
  /** Plugin Constructor */
  /*-------------------------------------------- */

  function Plugin(el, opts) {
    this.options = $.extend({}, defaults, opts);
    this.$el = $(el);

    this._init();
  }

  Plugin._hideActiveDropdown = function() {
    if (Plugin._activeDropdown) {
      Plugin._activeDropdown.hide();
    }
  };

  Plugin._setActiveDropdown = function(active) {
    // hide the current active dropdown (may or may not exist)
    Plugin._hideActiveDropdown();

    // set the new dropdown as the active one
    Plugin._activeDropdown = active;
  };

  $.extend(Plugin.prototype, {

    /*-------------------------------------------- */
    /** Private Methods */
    /*-------------------------------------------- */

    _init: function() {
      this._addListeners();
    },

    _addMouseLeaveDelayListeners: function() {
      var self = this;

      this.$el.on('mouseleave', function(e) {
        // Fixes firefox and other browsers that fire mouseleave event when opening select element
        if ($(e.target).is('select') && self.$el.has(e.target).length > 0) {
          e.stopPropagation();
          return;
        }

        self._mouseLeaveTimeout = setTimeout($.proxy(self.hide, self), self.options.mouseLeaveDelay);
      });

      this.$el.on('mouseenter', function(e) {
        self._clearTimeouts();
      });
    },

    _addListeners: function() {
      var self = this;

      if (this.options.mouseLeaveDelay) {
        self._addMouseLeaveDelayListeners();
      }

      if (this.options.trigger) {
        $(this.options.trigger).on(this.options.displayEvent, function(e) {
          e.preventDefault();

          if (Plugin._activeDropdown != self) {
            e.stopPropagation();
            self.show();
          }

        });
      }

      if (!Plugin._hasDocumentClickBeenAdded) {

        $(document).on('click.' + namespace, function(e) {
          // If any DOM element that *is not* the dropdown is clicked,
          // then hide the dropdown element.

          if (self.options.dismissOnDocumentClick &&
            Plugin._activeDropdown &&
            !$.contains(Plugin._activeDropdown.$el.get(0), e.target) &&
            e.target != self.$el.get(0)
            ) {
              Plugin._activeDropdown.hide();
            }
          });

          Plugin._hasDocumentClickBeenAdded = true;
        }
      },

      _clearTimeouts: function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._mouseLeaveTimeout);
      },

      _startHideTimeout: function() {
        if (!this.options.hideDelay) return;

        var self = this;
        // start a timeout to hide the dropdown after hideDelay threshold is eclipsed
        this._hideTimeout = setTimeout(function() {
          self.hide();
        }, this.options.hideDelay);
      },

      /*-------------------------------------------- */
      /** Public Methods */
      /*-------------------------------------------- */

      show: function() {
        // if the element is already shown, return
        if ( this.$el.hasClass(this.options.toggledClass) ) return;

        this._startHideTimeout();

        Plugin._setActiveDropdown(this);

        this.$el.addClass(this.options.toggledClass);
        this.options.showCallback();
      },

      hide: function() {
        // if the dropdown is already hidden, return
        if ( !this.$el.hasClass(this.options.toggledClass) )return;

        Plugin._activeDropdown = null;
        this._clearTimeouts();
        this.$el.removeClass(this.options.toggledClass);
        this.options.hideCallback();
      },

      destroy: function() {
        this.$el.off('mouseleave, mouseenter');

        if (Plugin._hasDocumentClickBeenAdded) {
          $(document).off('click.' + namespace);
        }

        if (this.options.trigger) {
          $(this.options.trigger).off(this.options.displayEvent);
        }
      }
    });

    /*-------------------------------------------- */
    /** Plugin Definition */
    /*-------------------------------------------- */

    $.fn.dropdown = function(options) {

      var method = false,
      methodArgs = arguments;

      if (typeof options == 'string') {
        method = options;
      }

      return this.each(function() {
        var plugin = $.data(this, namespace);

        if (!plugin) {
          $.data(this, namespace, new Plugin(this, options));
        } else if (method) {
          callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
        }
      });
    };

  }(jQuery));
  